import { Platform } from "@-/com.npmjs.react-native";
import { useSafeAreaInsets } from "@-/com.npmjs.react-native-safe-area-context";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import {
  FLOATING_TAB_BAR_BOTTOM_GAP_PX,
  FLOATING_TAB_BAR_HEIGHT_PX,
  PrimaryNavigationStripFadeInsetContext,
} from "@-/dev.improve.haniverse.lib.primary-navigation-strip";
import { useContext } from "react";

/** Clear the floating tabs and leave the same 9px gutter above their glass capsule. */
export function useBrowseTabsContentBottomInset({ trailingGap = 0 } = {}) {
  const { edgeInset } = useToolbarGridMetrics();
  const bottomTabFadeInset = useContext(PrimaryNavigationStripFadeInsetContext);
  const insets = useSafeAreaInsets();
  // NativeTabs supplies a per-screen SafeAreaProvider. Its bottom inset already includes
  // the native bar and its lower gutter; toolbar button diameter is not the tab height.
  if (Platform.OS === "ios") {
    // Include any margin already below the last surface in the upper gutter.
    return Math.max(0, insets.bottom + edgeInset - trailingGap);
  }
  return Platform.OS === "web"
    ? 0
    : Math.max(
        0,
        FLOATING_TAB_BAR_HEIGHT_PX +
          FLOATING_TAB_BAR_BOTTOM_GAP_PX +
          edgeInset +
          bottomTabFadeInset -
          trailingGap,
      );
}
